import { render } from "./FaqArticle.vue?vue&type=template&id=168d7508&scoped=true"
import script from "./FaqArticle.vue?vue&type=script&lang=js"
export * from "./FaqArticle.vue?vue&type=script&lang=js"

import "./FaqArticle.vue?vue&type=style&index=0&id=168d7508&scoped=true&lang=css"

import exportComponent from "C:\\Users\\manzurul\\AppData\\Local\\Jenkins.jenkins\\workspace\\Course-Manager-Support-Production\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168d7508"]])

export default __exports__